import { useMemo } from 'react';
import { useAuth } from '../context/AuthContext';
import { hasTenantPermission, hasAnyTenantPermission } from '../auth/permissions';

export function useTenantPermissions() {
  const { activeTenant, hasTenantPermission: check } = useAuth();
  const permissions = useMemo(
    () => activeTenant?.permissions || [],
    [activeTenant]
  );

  return {
    permissions,
    hasTenantPermission: (permission) =>
      check(permission) || hasTenantPermission(permissions, permission),
    hasAnyTenantPermission: (needed) => hasAnyTenantPermission(permissions, needed),
  };
}

export default useTenantPermissions;
